var _g, _circle, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFuelingProcess = function SvgFuelingProcess(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5609_31002)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_5609_31002)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#FEBE10"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.304 46.957h20.348c0 8.13 1.73 11.286 4.287 14.62 2.859 3.726 5.887 7.672 5.887 19.033H28.956c0-11.361-.511-15.307 2.348-19.034 2.558-3.333 0-6.49 0-14.619zM32.87 21.13h18.783v25.826H32.87V21.13z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.348 46.957H32.87c0 8.13 1.729 11.286 4.286 14.62 2.86 3.726 5.888 7.672 5.888 19.033H10.174c0-11.361 3.028-15.307 5.887-19.034 2.558-3.333 4.287-6.49 4.287-14.619zM20.348 21.13H32.87v25.826H20.348V21.13z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.782 39.13h13.305v21.13H36.783V39.13z",
    fill: "#F04F0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.913 39.13h7.044v4.695c0 .865-.701 1.566-1.566 1.566h-3.913c-.864 0-1.565-.701-1.565-1.566V39.13z",
    fill: "#A33100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.782 39.13H47.74v-18H36.782v18z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.782 28.174l10.957-1.565V21.13H36.782v7.044z",
    fill: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.217 63.195V21.13h1.566v42.065a5.283 5.283 0 1010.565 0v-8.022h1.565v8.022a6.848 6.848 0 11-13.696 0z",
    fill: "#A33100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.913 48.522v7.043h-3.13v-4.304l1.956-2.348-1.957-2.348V45l3.13 3.522z",
    fill: "#A33100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.652 14.086c0-.864.7-1.565 1.565-1.565h37.566c.864 0 1.565.701 1.565 1.565v7.044c0 .864-.701 1.565-1.566 1.565H17.218c-.864 0-1.565-.7-1.565-1.565v-7.043z",
    fill: "#F04F0A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5609_31002"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h72v72H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_5609_31002",
    x: 0,
    y: -3,
    width: 72,
    height: 75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_5609_31002"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFuelingProcess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "fueling-process.bd6a2033ca0276227353c4d96badeace.svg";